import { apiUrl } from "../enviroments/enviroments.dev";
import { Api } from "./Api";

const target = "/payments";

// Envio (pagamento): empresa OUT + fornecedor OUT, single-asset.
export interface CreatePaymentPayload {
  organization_id: number;
  target_supplier_id: number;
  asset_id: number;
  value: number;
}

export class PaymentsService {
  public static create(payload: CreatePaymentPayload): Promise<any> {
    return Api.post(apiUrl(`${target}/create`), payload);
  }

  public static getByOrganization(orgId: number): Promise<Array<any>> {
    return Api.get(apiUrl(`${target}/organization/${orgId}`));
  }
}
